import { render, staticRenderFns } from "./controlpanel.vue?vue&type=template&id=053acaf9&"
import script from "./controlpanel.js?vue&type=script&lang=js&"
export * from "./controlpanel.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053acaf9')) {
      api.createRecord('053acaf9', component.options)
    } else {
      api.reload('053acaf9', component.options)
    }
    module.hot.accept("./controlpanel.vue?vue&type=template&id=053acaf9&", function () {
      api.rerender('053acaf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/controlpanel.vue"
export default component.exports